import React, { useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { joinClasses } from '../../../Utils/className.util';
import apiClient from '../../../Services/ApiClient';
import useTranslation from '../../../Hooks/useTranslation';
import Text from '../../BaseModule/Components/Text';
import useApiClient from '../../../Hooks/useApiClient';
import FormWrapper from '../../BaseModule/Components/Form/FormWrapper';
import InputField from '../../BaseModule/Components/Form/Components/InputField';
import RemoveConfirmationModal from '../../BaseModule/Components/RemoveConfirmation/RemoveConfirmationModal';
import ConfirmationModal from '../../BaseModule/Components/Confirmation/ConfirmationModal';
import SubmitButton from '../../BaseModule/Components/Button/SubmitButton';
import styles from './AccountRemoveRequest.module.scss';

const AccountRemoveRequest: React.FC = () => {
	const { t } = useTranslation();
	const { displayError, displaySuccess } = useApiClient();
	const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] =
		useState(false);
	const [email, setEmail] = useState(null);
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

	const validationSchema = yup.object({
		email: yup
			.string()
			.email(t('validation.patientManualRegistrationLatamForm.email'))
			.required(t('validation.patientManualRegistrationLatamForm.email')),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = (values: any) => {
		if (values?.email) {
			setEmail(values.email);
		}
		setIsRemoveConfirmationOpen(true);
	};

	const handleRemoveAccount = async () => {
		try {
			const response = await apiClient.post(
				`/user/${email}/delete-request`,
				{},
			);
			if (response) {
				setIsConfirmationOpen(true);
			}
		} catch (e) {
			displayError(e);
		}
		setIsRemoveConfirmationOpen(false);
	};

	return (
		<div className={styles.wrapper}>
			<h1 className={styles.title}>
				{t('component.accountRemoveRequest.title')}
			</h1>
			<Text tx='component.accountRemoveRequest.text' />
			<div className={styles.formWrapper}>
				<FormWrapper formMethods={formMethods}>
					<InputField name='email' label='base.shared.email' isRequired />
					<SubmitButton
						onSubmit={handleSubmit}
						className={joinClasses(['btn btn-primary w-100', styles.button])}
						title='base.shared.remove2'
					/>
				</FormWrapper>
			</div>
			{isRemoveConfirmationOpen && (
				<RemoveConfirmationModal
					opened={isRemoveConfirmationOpen}
					onClose={() => setIsRemoveConfirmationOpen(false)}
					onConfirm={handleRemoveAccount}
					confirmationText='component.accountRemoveRequest.confirmationText'
					confirmationTitle='component.accountRemoveRequest.confirmationTitle'
				/>
			)}
			{isConfirmationOpen && (
				<ConfirmationModal
					imageSource='/dist/icons/v2/check-green.svg'
					title='component.accountRemoveRequest.confirmationModalTitle'
					text={t('component.accountRemoveRequest.confirmationModalText') ?? ''}
					isOpen={isConfirmationOpen}
					onClose={() => setIsConfirmationOpen(false)}
				/>
			)}
		</div>
	);
};

export default AccountRemoveRequest;
